"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _trtcJsSdk = _interopRequireDefault(require("trtc-js-sdk"));
var _detect = require("@/views/trial/videoTrial/components/Detect/detect.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {},
  props: {},
  data: function data() {
    return {
      hasCameraDevice: false,
      hasMicDevice: false,
      hasVoiceDevice: false,
      hasCameraConnect: null,
      hasVoiceConnect: null,
      hasMicConnect: null,
      hasNetworkConnect: null,
      cameraTestingResult: {},
      voiceTestingResult: {},
      micTestingResult: {},
      networkTestingResult: {
        uplinkNetworkQualities: [],
        downlinkNetworkQualities: [],
        rttList: [],
        average: {
          rtt: 0,
          uplinkNetworkQuality: 0,
          downlinkNetworkQuality: 0
        }
      },
      completedTestingPageIdList: [],
      curTestingPageId: "",
      localStream: null,
      client: null,
      timeout: null,
      networkQualityNum: 0,
      deviceFailAttention: "1. 若浏览器弹出提示，请选择“允许”<br>" + "2. 若杀毒软件弹出提示，请选择“允许”<br>" + "3. 检查系统设置，允许浏览器访问摄像头及麦克风<br>" + "4. 检查浏览器设置，允许网页访问摄像头及麦克风<br>" + "5. 检查摄像头/麦克风是否正确连接并开启<br>" + "6. 尝试重新连接摄像头/麦克风<br>" + "7. 尝试重启设备后重新检测",
      networkFailAttention: "1. 请检查设备是否联网<br>" + "2. 请刷新网页后再次检测<br>" + "3. 请尝试更换网络后再次检测",
      NETWORK_QUALITY: {
        "0": "未知",
        "1": "极佳",
        "2": "较好",
        "3": "一般",
        "4": "差",
        "5": "极差",
        "6": "断开"
      },
      pageCallbackConfig: {
        "camera-testing-body": "startCameraTesting",
        "voice-testing-body": "startVoiceTesting",
        "mic-testing-body": "startMicTesting",
        "network-testing-body": "startNetworkTesting"
      },
      // --------
      //是否检查通过
      prepareConnectInfo: "",
      prepareConnectColor: "#909399",
      prepareConnectBtn: "开始检测",
      hasPrepareSuccess: false,
      hasPrepareLoading: false,
      hasPrepareFinish: false,
      preparePercentage: 0,
      //进度条
      detectStep: 0,
      //   hasPrepareCameraSuccess: false,
      //   hasPrepareVoiceSuccess: false,
      //   hasPrepareMicSuccess: false,
      //   hasPrepareNetworkSuccess: false,
      cameraDeviceOptions: [],
      cameraDeviceOptionValue: "",
      voiceDeviceOptions: [],
      voiceDeviceOptionValue: "",
      micDeviceOptions: [],
      micDeviceOptionValue: "",
      micVolumeNum: 0,
      networkResultValue: {
        os: "",
        browser: ""
      }
    };
  },
  watch: {
    detectStep: function detectStep(val, old) {
      if (val == 1) {
        this.startCameraTesting();
      } else if (val == 2) {
        this.startVoiceTesting();
      } else if (val = 3) {
        this.startMicTesting();
      } else if (val == 4) {
        this.startNetworkTesting();
      }
    }
  },
  computed: {
    isFileProtocol: function isFileProtocol() {
      return location.protocol === "file:";
    },
    isSafari: function isSafari() {
      return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && !/CriOS/.test(navigator.userAgent) && !/FxiOS/.test(navigator.userAgent) && !/EdgiOS/.test(navigator.userAgent);
    },
    isFirefox: function isFirefox() {
      return /Firefox/i.test(navigator.userAgent);
    },
    noVoiceDevice: function noVoiceDevice() {
      return this.isSafari || this.isFirefox;
    }
  },
  methods: {
    handlePrepareStart: function () {
      var _handlePrepareStart = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(e) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log(e);
              if (!(e.target.innerText == "进一步检测")) {
                _context.next = 5;
                break;
              }
              //
              this.detectStep = 1;
              _context.next = 7;
              break;
            case 5:
              _context.next = 7;
              return this.startDeviceConnect();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handlePrepareStart(_x) {
        return _handlePrepareStart.apply(this, arguments);
      }
      return handlePrepareStart;
    }(),
    // -----------------------------------
    hideVoiceTesting: function hideVoiceTesting() {},
    /**
     * 弹窗-设备连接检查
     */
    startDeviceConnect: function () {
      var _startDeviceConnect = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var _this, prepareLoading;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getDevicesInfo();
            case 2:
              _this = this;
              this.hasPrepareLoading = true;
              this.preparePercentage = 0;
              this.hasPrepareFinish = false;
              this.prepareConnectInfo = "设备正在连接中，请稍等";
              this.prepareConnectColor = "#909399";
              //
              prepareLoading = window.setInterval(function () {
                _this.preparePercentage = _this.preparePercentage + 10;
                if (_this.preparePercentage >= 100) {
                  console.log("time");
                  window.clearInterval(prepareLoading);
                  _this.hasPrepareLoading = false;
                  _this.hasPrepareFinish = true;
                  var connectResult = _this.hasCameraConnect && _this.hasVoiceConnect && _this.hasMicConnect && _this.hasNetworkConnect;
                  if (connectResult) {
                    _this.prepareConnectInfo = "设备及网络连接成功，请关闭进入";
                    _this.prepareConnectBtn = "重新检测";
                    _this.$emit("success");
                    //  _this.prepareConnectInfo = "设备及网络连接成功，请开始设备检测";
                    // _this.prepareConnectBtn = "进一步检测";

                    _this.prepareConnectColor = "#67C23A";
                  } else {
                    // 有设备或者网络连接不成功，展示连接失败提示
                    var connectInfo = _this.getDeviceConnectInfo();
                    _this.prepareConnectInfo = connectInfo;
                    _this.prepareConnectColor = "#F56C6C";
                  }
                }
              }, 200);
              if (!(this.hasCameraConnect && this.hasMicConnect)) {
                navigator.mediaDevices.getUserMedia({
                  video: this.hasCameraDevice,
                  audio: this.hasMicDevice
                }).then(function () {
                  if (_this2.hasCameraDevice) _this2.hasCameraConnect = true;
                  if (_this2.hasMicDevice) _this2.hasMicConnect = true;
                }).catch(function (err) {
                  console.log("getUserMedia err", err.name, err.message);
                  handleGetUserMediaError(err);
                });
              }
              //   this.initTestingTabTitle();
              // 在设备检测弹窗显示设备连接信息
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function startDeviceConnect() {
        return _startDeviceConnect.apply(this, arguments);
      }
      return startDeviceConnect;
    }(),
    /**
     * 获取设备信息及网络连接信息
     */
    getDevicesInfo: function () {
      var _getDevicesInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this3 = this;
        var cameraList, micList, voiceList;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _trtcJsSdk.default.getCameras();
            case 2:
              cameraList = _context3.sent;
              _context3.next = 5;
              return _trtcJsSdk.default.getMicrophones();
            case 5:
              micList = _context3.sent;
              _context3.next = 8;
              return _trtcJsSdk.default.getSpeakers();
            case 8:
              voiceList = _context3.sent;
              this.hasCameraDevice = cameraList.length > 0;
              this.hasMicDevice = micList.length > 0;
              this.hasVoiceDevice = voiceList.length > 0;
              cameraList.forEach(function (camera) {
                if (camera.deviceId.length > 0) {
                  _this3.hasCameraConnect = true;
                }
              });
              micList.forEach(function (mic) {
                if (mic.deviceId.length > 0) {
                  _this3.hasMicConnect = true;
                }
              });
              // 如果是无法进行扬声器检测的浏览器，设置为true
              if (this.noVoiceDevice) {
                this.hasVoiceDevice = true;
                this.hasVoiceConnect = true;
              } else {
                this.hasVoiceConnect = voiceList.length > 0;
              }
              // 本地打开使用 navigator.onLine 的结果，https打开使用 isOnline() 的检测结果
              // CORS policy: Cross origin requests are only supported for protocol schemes: http, data, chrome, chrome-extension, chrome-untrusted, https;
              if (!this.isFileProtocol) {
                _context3.next = 19;
                break;
              }
              _context3.t0 = navigator.onLine;
              _context3.next = 22;
              break;
            case 19:
              _context3.next = 21;
              return this.isOnline();
            case 21:
              _context3.t0 = _context3.sent;
            case 22:
              this.hasNetworkConnect = _context3.t0;
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getDevicesInfo() {
        return _getDevicesInfo.apply(this, arguments);
      }
      return getDevicesInfo;
    }(),
    /**
     * 摄像头检测页-检测展示摄像头设备选择列表
     */
    updateCameraDeviceList: function () {
      var _updateCameraDeviceList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var _this4 = this;
        var cameraDevices, cacheCameraDevice;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _trtcJsSdk.default.getCameras();
            case 2:
              cameraDevices = _context4.sent;
              this.cameraDeviceOptions = [];
              cameraDevices.forEach(function (camera) {
                _this4.cameraDeviceOptions.push({
                  label: camera.label,
                  value: camera.deviceId
                });
              });
              cacheCameraDevice = cameraDevices.filter(function (camera) {
                return camera.deviceId === localStorage.getItem("txy_webRTC_cameraId");
              });
              if (cacheCameraDevice.length > 0) {
                // $("#camera-select").val(localStorage.getItem("txy_webRTC_cameraId"));
                this.cameraTestingResult.device = cacheCameraDevice[0];
              } else {
                // $("#camera-select").val(cameraDevices[0].deviceId);
                this.cameraTestingResult.device = cameraDevices[0];
              }
              this.cameraDeviceOptionValue = this.cameraTestingResult.device.deviceId;
              console.log(cameraDevices);
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateCameraDeviceList() {
        return _updateCameraDeviceList.apply(this, arguments);
      }
      return updateCameraDeviceList;
    }(),
    /**
     * 摄像头设备测试
     */
    startCameraTesting: function () {
      var _startCameraTesting = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.updateCameraDeviceList();
            case 2:
              _context5.next = 4;
              return this.createLocalStream({
                audio: false,
                video: true,
                cameraId: this.cameraTestingResult.device.deviceId
              }, "camera-video");
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function startCameraTesting() {
        return _startCameraTesting.apply(this, arguments);
      }
      return startCameraTesting;
    }(),
    updateVoiceDeviceList: function () {
      var _updateVoiceDeviceList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var _this5 = this;
        var voiceDevices, cacheVoiceDevice;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _trtcJsSdk.default.getSpeakers();
            case 2:
              voiceDevices = _context6.sent;
              // voiceDevices = voiceDevices.filter(voice => voice.deviceId !== 'default');
              // $("#voice-select").empty();
              this.voiceDeviceOptions = [];
              voiceDevices.forEach(function (voice) {
                _this5.voiceDeviceOptions.push({
                  label: voice.label,
                  value: voice.deviceId
                });
              });

              // 如果有用户设备选择缓存，优先使用缓存的deviceId
              cacheVoiceDevice = voiceDevices.filter(function (mic) {
                return mic.deviceId === localStorage.getItem("txy_webRTC_voiceId");
              });
              if (cacheVoiceDevice.length > 0) {
                // $("#voice-select").val(localStorage.getItem("txy_webRTC_voiceId"));
                this.voiceTestingResult.device = cacheVoiceDevice[0];
              } else {
                // $("#voice-select").val(voiceDevices[0].deviceId);
                this.voiceTestingResult.device = voiceDevices[0];
              }
              this.voiceDeviceOptionValue = this.voiceTestingResult.device.deviceId;
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateVoiceDeviceList() {
        return _updateVoiceDeviceList.apply(this, arguments);
      }
      return updateVoiceDeviceList;
    }(),
    startVoiceTesting: function () {
      var _startVoiceTesting = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.updateVoiceDeviceList();
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function startVoiceTesting() {
        return _startVoiceTesting.apply(this, arguments);
      }
      return startVoiceTesting;
    }(),
    updateMicDeviceList: function () {
      var _updateMicDeviceList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8() {
        var _this6 = this;
        var micDevices, cacheMicDevice;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _trtcJsSdk.default.getMicrophones();
            case 2:
              micDevices = _context8.sent;
              // micDevices = micDevices.filter(mic => mic.deviceId !== 'default');

              // console.log(getOS());
              // let isAndroid = getOS().type === "mobile" && getOS().osName === "Android";
              // // 如果是安卓设备，不允许切换麦克风(切换麦克风存在获取不到音量的情况)
              // if (isAndroid) {
              //   micDevices = [].concat(micDevices[0]);
              // }

              // $("#mic-select").empty();
              this.micDeviceOptions = [];
              micDevices.forEach(function (mic) {
                // let option = $("<option></option>");
                // option.attr("value", mic.deviceId);
                // option.html(mic.label);
                // option.appendTo("#mic-select");
                _this6.micDeviceOptions.push({
                  label: mic.label,
                  value: mic.deviceId
                });
              });

              // 如果有用户设备选择缓存，优先使用缓存的deviceId
              cacheMicDevice = micDevices.filter(function (mic) {
                return mic.deviceId === localStorage.getItem("txy_webRTC_micId");
              }); // if (isAndroid || cacheMicDevice.length === 0) {
              if (cacheMicDevice.length > 0) {
                // $("#mic-select").val(micDevices[0].deviceId);
                this.micTestingResult.device = cacheMicDevice[0];
              } else {
                // $("#mic-select").val(localStorage.getItem("txy_webRTC_micId"));
                this.micTestingResult.device = micDevices[0];
              }
              this.micDeviceOptionValue = this.micTestingResult.device.deviceId;
            case 8:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateMicDeviceList() {
        return _updateMicDeviceList.apply(this, arguments);
      }
      return updateMicDeviceList;
    }(),
    startMicTesting: function () {
      var _startMicTesting = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9() {
        var _this7 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.updateMicDeviceList();
            case 2:
              _context9.next = 4;
              return this.createLocalStream({
                audio: true,
                microphoneId: this.micTestingResult.device.deviceId,
                video: false
              }, "audio-container");
            case 4:
              setInterval(function () {
                var volume = _this7.localStream.getAudioLevel();
                _this7.micVolumeNum = Math.ceil(28 * volume);
              }, 100);
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function startMicTesting() {
        return _startMicTesting.apply(this, arguments);
      }
      return startMicTesting;
    }(),
    startNetworkTesting: function () {
      var _startNetworkTesting = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10() {
        var OSInfo, browser, countDown;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.networkQualityNum = 0;
              OSInfo = (0, _detect.getOS)();
              console.log(OSInfo);
              browser = (0, _detect.getBrowser)();
              console.log(browser);
              countDown = 15;
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function startNetworkTesting() {
        return _startNetworkTesting.apply(this, arguments);
      }
      return startNetworkTesting;
    }(),
    /**
     * 判断是否有网络连接
     */
    isOnline: function isOnline() {
      return new Promise(function (resolve) {
        try {
          var xhr = new XMLHttpRequest();
          xhr.onload = function () {
            resolve(true);
          };
          xhr.onerror = function () {
            resolve(false);
          };
          xhr.open("GET", "data/mock.json", true);
          xhr.send();
        } catch (err) {
          // console.log(err);
        }
      });
    },
    createLocalStream: function () {
      var _createLocalStream = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee11(constraints, container) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.localStream = _trtcJsSdk.default.createStream(constraints);
              _context11.prev = 1;
              _context11.next = 4;
              return this.localStream.initialize();
            case 4:
              _context11.next = 9;
              break;
            case 6:
              _context11.prev = 6;
              _context11.t0 = _context11["catch"](1);
              handleGetUserMediaError(_context11.t0);
            case 9:
              container && this.localStream.play(container);
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[1, 6]]);
      }));
      function createLocalStream(_x2, _x3) {
        return _createLocalStream.apply(this, arguments);
      }
      return createLocalStream;
    }(),
    getDeviceConnectInfo: function getDeviceConnectInfo() {
      var connectInfo = "连接出错，请重试";
      // 第一步：浏览器未检测到摄像头/麦克风/扬声器设备的提示
      if (!(this.hasCameraDevice && this.hasMicDevice && this.hasVoiceDevice)) {
        connectInfo = "\u672A\u68C0\u6D4B\u5230".concat(this.hasCameraDevice ? "" : "【摄像头】").concat(this.hasVoiceDevice ? "" : "【扬声器】").concat(this.hasMicDevice ? "" : "【麦克风】", "\u8BBE\u5907\uFF0C\u8BF7\u68C0\u67E5\u8BBE\u5907\u8FDE\u63A5");
        return connectInfo;
      }
      // 第二步：浏览器未拿到摄像头/麦克风权限的提示
      if (!(this.hasCameraConnect && this.hasMicConnect)) {
        connectInfo = this.hasNetworkConnect ? "请允许浏览器及网页访问摄像头/麦克风设备" : "请允许浏览器及网页访问摄像头/麦克风设备，并检查网络连接";
        // 显示设备连接失败引导
        // $("#connect-attention-container").show();
        // $("#connect-attention-info").html(deviceFailAttention);
        return connectInfo;
      }
      // 第三步：浏览器检测未连接网络的提示
      if (!this.hasNetworkConnect) {
        connectInfo = "网络连接失败，请检查网络连接";
        // 显示设备连接失败引导
        // $("#connect-attention-container").show();
        // $("#connect-attention-info").html(networkFailAttention);
        return connectInfo;
      }
      return connectInfo;
    },
    handleCameraBtnYes: function handleCameraBtnYes() {
      this.detectStep = 2;
    },
    handleCameraBtnNo: function handleCameraBtnNo() {},
    handleVoiceBtnYes: function handleVoiceBtnYes() {
      this.detectStep = 3;
    },
    handleVoiceBtnNo: function handleVoiceBtnNo() {},
    handleMicBtnYes: function handleMicBtnYes() {
      this.detectStep = 4;
    },
    handleMicBtnNo: function handleMicBtnNo() {}
    /**
     * 抽离createStream的公共处理函数
     */
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee12() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            //safari和firefox浏览器中隐藏扬声器相关检测
            this.noVoiceDevice && this.hideVoiceTesting();
            _context12.next = 3;
            return this.startDeviceConnect();
          case 3:
          case "end":
            return _context12.stop();
        }
      }, _callee12, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }()
};
exports.default = _default;